import React from 'react'

import { KeypadButton } from './KeypadButton'
import { CallButton } from './CallButton'
import { BackspaceButton } from './BackspaceButton'
import { HideKeypadButton } from './HideKeypadButton'
import { CancelCallButton } from './CancelCallButton'

export const TYPES = {
    CALL: 'CALL',
    DTMF: 'DTMF',
    ADD: 'ADD',
    TRANSFER: 'TRANSFER'
}

export default function PhoneKeypad(props) {
    const { addInputValue, onBackspace, onCallHandler, onClickCancel, toggleKeypad, keypadType = TYPES.CALL } = props

    function renderLeftFooterKey() {
        if (keypadType === TYPES.ADD || keypadType === TYPES.TRANSFER || keypadType === TYPES.DTMF) {
            return <HideKeypadButton onClick={toggleKeypad} />
        }
        return <div className="dialpad__emptyBox"></div>
    }

    function renderCenterFooterKey() {
        switch (keypadType) {
            case TYPES.ADD:
            case TYPES.TRANSFER:
            case TYPES.CALL:
                return onCallHandler && <CallButton onClick={onCallHandler} />
            case TYPES.DTMF:
                return onClickCancel && <CancelCallButton onClick={onClickCancel} />
            default:
                return <div className="dialpad__emptyBox"></div>
        }
    }

    return (
        <div className="dialpad__keypad" dir="ltr">
            <div className="d-flex justify-content-between">
                <KeypadButton setInputValue={addInputValue} number={1} />
                <KeypadButton setInputValue={addInputValue} number={2} letters="ABC" />
                <KeypadButton setInputValue={addInputValue} number={3} letters="DEF" />
            </div>
            <div className="d-flex justify-content-between">
                <KeypadButton setInputValue={addInputValue} number={4} letters="GHI" />
                <KeypadButton setInputValue={addInputValue} number={5} letters="JKL" />
                <KeypadButton setInputValue={addInputValue} number={6} letters="MNO" />
            </div>
            <div className="d-flex justify-content-between">
                <KeypadButton setInputValue={addInputValue} number={7} letters="PQRS" />
                <KeypadButton setInputValue={addInputValue} number={8} letters="TUV" />
                <KeypadButton setInputValue={addInputValue} number={9} letters="WXYZ" />
            </div>
            <div className="d-flex justify-content-between">
                <KeypadButton setInputValue={addInputValue} number="*" centered />
                <KeypadButton setInputValue={addInputValue} number={0} letters="+" />
                <KeypadButton setInputValue={addInputValue} number="#" centered />
            </div>
            <div className="dialpad__keypad__footer-wrp d-flex justify-content-between">
                {renderLeftFooterKey()}
                {renderCenterFooterKey()}
                <BackspaceButton {...{ onBackspace }} />
            </div>
        </div>
    )
}
